import { SEAL_NUMBER_VALID_LENGTH } from '@/store/modules/drs/drs-stores-bags.module'
import { OPERATOR_CODES } from '@/utils/constants/drs/operators'

export const SEAL_WARNING = {
    UNKNOWN_PREFIX: 'unknown-prefix',
    OTHER_OPERATOR: 'other-operator',
    INVALID_SEAL: 'invalid-seal',
    OTHER_OPERATOR_INVALID: 'other-operator-invalid'
}

const SEAL_PREFIX_LENGTH = 2

const DAMM_MATRIX = [
    [0, 3, 1, 7, 5, 9, 8, 6, 4, 2],
    [7, 0, 9, 2, 1, 5, 4, 8, 6, 3],
    [4, 2, 0, 6, 8, 7, 1, 3, 5, 9],
    [1, 7, 5, 0, 9, 8, 3, 4, 2, 6],
    [6, 1, 2, 3, 0, 4, 5, 9, 7, 8],
    [3, 6, 7, 4, 2, 0, 9, 5, 8, 1],
    [5, 8, 6, 9, 7, 2, 0, 1, 3, 4],
    [8, 9, 4, 5, 3, 6, 2, 0, 1, 7],
    [9, 4, 3, 8, 6, 1, 7, 2, 0, 5],
    [2, 5, 8, 1, 4, 3, 6, 7, 9, 0]
]

function hasDammCheckDigit(sealNumber) {
    let interim = 0

    for (const char of sealNumber) {
        const digit = parseInt(char, 10)
        if (Number.isNaN(digit)) return false
        interim = DAMM_MATRIX[interim][digit]
    }

    return interim === 0
}

function isPskPrefix(sealNumber, services = []) {
    const prefix = sealNumber.slice(0, SEAL_PREFIX_LENGTH)
    if (prefix.length < SEAL_PREFIX_LENGTH) return false

    // Operator PSK is recognized by the typed prefix and does not use the Damm check
    return services.some(service =>
        service.code === OPERATOR_CODES.PSK && service.sealPrefix === prefix
    )
}

function hasValidCheckDigit(sealNumber, services) {
    if (!sealNumber) return false
    return isPskPrefix(sealNumber, services) || hasDammCheckDigit(sealNumber)
}

export function getSealRequirements({ sealNumber, preferredPrefix, services }) {
    const number = String(sealNumber || '')
    const prefix = number.slice(0, SEAL_PREFIX_LENGTH)

    return [
        {
            key: 'length',
            label: `składać się z ${SEAL_NUMBER_VALID_LENGTH} znaków`,
            valid: number.length === SEAL_NUMBER_VALID_LENGTH
        },
        {
            key: 'checkDigit',
            label: 'mieć prawidłową cyfrę kontrolną',
            valid: hasValidCheckDigit(number, services)
        },
        {
            key: 'prefix',
            label: 'zaczynać się od prefiksu preferowanego operatora',
            valid: Boolean(preferredPrefix && prefix === preferredPrefix),
            tooltip: 'Jeśli zamkniesz worek przy użyciu plomby, która nie jest powiązana z żadnym operatorem,<br/>wydasz go własnym transportem.'
        }
    ]
}

export function resolveSealWarning({ sealNumber, preferredPrefix, knownPrefixes = [], services }) {
    const number = String(sealNumber || '')
    const prefix = number.slice(0, SEAL_PREFIX_LENGTH)
    const isKnownPrefix = prefix.length === SEAL_PREFIX_LENGTH && knownPrefixes.includes(prefix)
    const isSealValid = number.length === SEAL_NUMBER_VALID_LENGTH && hasValidCheckDigit(number, services)

    if (!isKnownPrefix) return SEAL_WARNING.UNKNOWN_PREFIX

    if (preferredPrefix && prefix !== preferredPrefix) {
        return isSealValid ? SEAL_WARNING.OTHER_OPERATOR : SEAL_WARNING.OTHER_OPERATOR_INVALID
    }

    return isSealValid ? null : SEAL_WARNING.INVALID_SEAL
}
